/**
 * 监测点类型模块
 * date:2022 03 30 fuck
 */
import httpRequest from '@/utils/request.js';

/**监测点类型列表接口 */
export const carrierTypeList = (params = {}) => httpRequest.httpGet({
    url: '/service/carrierType/list', params: {
        ...params
    }
});
/**监测点类型列表接口 */
export const carrierTypeDetail = (id) => httpRequest.httpGet({
    url: '/service/carrierType/detail/' + id
});
/**新增监测点类型接口 */
export const carrierTypeAdd = (data = {}) => httpRequest.httpPost('/service/carrierType/add', data);
/**编辑监测点类型接口 */
export const carrierTypeEdited = (data = {}) => httpRequest.httpPost('/service/carrierType/edited', data);
/**删除监测点类型接口 */
export const carrierTypeDelete = (data = {}) => httpRequest.httpdelete('/service/carrierType/delete', data);